import React from 'react';
import { Trans } from 'react-i18next';

import { LinkExternal } from 'src/shared/components';
import { CheckboxField } from 'src/shared/components/forms';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { External } from 'src/shared/route';

const TermsOfServiceField = () => {
  const t = useTranslate(TranslationNamespace.SIGN_UP);

  return (
    <CheckboxField
      ariaLabel={t('termsAgreement')}
      data-testid="has-agreed-to-terms"
      label=""
      name="hasAgreedToTerms"
    >
      <Trans
        components={{
          TermsOfServiceLink: (
            <LinkExternal href={External.TERMS_OF_SERVICE.path} />
          ),
          PrivacyPolicyLink: (
            <LinkExternal href={External.PRIVACY_POLICY.path} />
          ),
        }}
        i18nKey="byCreatingAnAccount"
        t={t}
      />
    </CheckboxField>
  );
};

export { TermsOfServiceField };
